import Vue from 'vue'
import VueRouter from 'vue-router'

import AuthView from '@/views/auth/AuthView'
import FinancasView from '@/views/financas/FinancasView'
import LembretesView from '@/views/lembretes/LembretesView'
import AdminUsuariosView from '@/views/admin/AdminUsuariosView'
import Error404View from '../views/Error404View'


Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    name: 'error404',
    component: Error404View,
    meta: { headerFooter: false }
  },

  {
    path: '/',
    name: 'auth',
    component: AuthView,
    meta: { headerFooter: false }
  },

  {
    path: '/financas/',
    name: 'financas',
    component: FinancasView,
    meta: { headerFooter: true }
  },

  {
    path: '/lembretes/',
    name: 'lembretes',
    component: LembretesView,
    meta: { headerFooter: true }
  },

  {
    path: '/admin/',
    name: 'admin',
    component: AdminUsuariosView,
    meta: { headerFooter: true }
  },
]

const router = new VueRouter({
  routes
})

export default router
